
<!-- <template src="./login.html"></template> -->
<template>
	<div class="login_container">
		<div class="container">
			<h4>Welcome to {{siteTitle}}</h4>

			<div class="card" v-if='!show_ga'>
				<div class="card-header"> Login </div>
				<div class="card-block">

					<form v-on:submit.prevent="loginUser()">
						<div class="form-group row" :class="{ 'has-error': errors.has('username') }">
							<div class="col-3"><label class="float-right" for="username">Username</label> </div>
							<div class="col-6"> <input type="text" v-validate="'required'" name="username" id="username" v-model="user.username" class="form-control" autofocus></div>
							<div class='col-3'><small v-show="errors.has('username')"> {{ errors.first('username') }}</small></div>
						</div>
						<div class="form-group row" :class="{ 'has-error': errors.has('password') }">
							<div class="col-3"> <label class="float-right" for="username">Password</label> </div>
							<div class="col-6"><input type="password" v-validate="'required'" name="password" id="password" v-model="user.password" class="form-control"></div>
							<div class='col-3'><small v-show="errors.has('password')"> {{ errors.first('password') }}</small></div>
						</div>

						<div class="form-group row justify-content-center">
							<button type="submit" class="btn btn-primary" :disabled='errors.any()'>Submit</button>
							<router-link to="/register" class="btn btn-link">Register</router-link>
							<router-link to="/forgetPassword" class="btn btn-link">Reset password</router-link>
						</div>
					</form>
				</div>
			</div>
			
			<div class = 'card' v-if='show_ga'>
				<div class="card-header"> Two-Factor authentication (Google Authenticator) for {{user.username}}</div>
				<div class="card-block">
					<p class = 'text-center' v-if='user.ga_status=="new"'>
						<img :src='user.qr_img_src'>
					</p>
					<p class = 'text-center' v-if='user.ga_status=="new"'>Install Google Authenticator for <a href = 'http://appstore.com/googleauthenticator' target = '_blank'>iOS</a> or <a href = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2' target = '_blank'>Android</a>.</p>
					<div>
						<b-form inline v-on:submit.prevent="gaUser()">
						<label class = 'col-4' for="inlineFormInputCode">Google Authenticator Code</label>
						<b-input class="col-4" size = '6' id="inlineFormInputCode" placeholder="cd s" v-model="user.ga_code" autofocus/>
						<b-button variant="primary" type = 'submit'>Login</b-button>
					</b-form>
				</div>
			</div>
		</div>
			
	</div>
</div>
</template>

<script>
import {siteTitle} from '@/app_config';
import {Bus} from '@/bus'


export default {
	name: 'login',
	data () {
		return {
			siteTitle:siteTitle,
			user:{username:'',password:'',ga_code: '',qr_img_src: '',user_id: '',ga_status: ''},
			show_ga: false
		}
	},

	methods:{
		loginUser () {
			var vm = this;
			vm.$validator.validateAll().then((result) => {
				if (result){
					vm.$store.dispatch('login',vm.user).then((user) => {
						if (user.ga_status !== undefined){
							vm.show_ga = true;
							vm.user.password = '';
							vm.user.username = user.login;
							vm.user.user_id = user.user_id;
							vm.user.qr_img_src = user.qr_img_src;
							vm.user.ga_status = user.ga_status;
						}
						else{
							vm.$snotify.success('logged in successfully');
							Bus.$emit('user.updated',true);
							var nextPage = (user.is_password_reset=='Y') ? 'setnewpassword' : (vm.$route.query.redirect) ? vm.$route.query.redirect : '/';
							vm.$router.push(nextPage);								
						}
					}).catch((err) => {
						if (!_.isEmpty(err)) vm.$snotify.error(err);
					});
				}
			})
		},
		gaUser () {
			var vm = this;
			vm.$store.dispatch('loginGA',vm.user).then((user) => {
				vm.$snotify.success('logged in successfully');
				Bus.$emit('user.updated',true);
				var nextPage = (user.is_password_reset=='Y') ? 'setnewpassword' : (vm.$route.query.redirect) ? vm.$route.query.redirect : '/';
				vm.$router.push(nextPage);								
			}).catch((err) => {
				if (!_.isEmpty(err)) vm.$snotify.error(err);
			});
		}
				
	},
	created (){
		this.$store.dispatch('logout');
		Bus.$emit('user.updated',true);
	}
}
</script>

	<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login_container{
	margin-top:100px;
}
form{
	margin:20px 0;
}
.card{
	margin:20px 0;
}
</style>
		










